"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDirectionEnum = void 0;
/**
 * MONEY - означає що користувач вводить сумму, яку він хоче витратити на покупку
 * COINTS - означає що він вводить кількість ігрової валюти яку кількістья кої хоче придбати
 * NONE - початковий стан калькулятора коли користувач ще не почав вводити дані
 */
var InputDirectionEnum;
(function (InputDirectionEnum) {
    InputDirectionEnum[InputDirectionEnum["MONEY"] = 1] = "MONEY";
    InputDirectionEnum[InputDirectionEnum["COINTS"] = 2] = "COINTS";
    InputDirectionEnum[InputDirectionEnum["SALE"] = 4] = "SALE";
    InputDirectionEnum[InputDirectionEnum["NONE"] = 3] = "NONE";
})(InputDirectionEnum = exports.InputDirectionEnum || (exports.InputDirectionEnum = {}));
